<template lang="pug">
  v-container: v-layout(justify-center): v-flex(xs12 md10)
    v-toolbar(flat)
      v-toolbar-title {{ $tc('department.title', 2) }}
      v-spacer
      v-dialog(v-model="dialog" max-width="500px")
        template(v-slot:activator="{ on }")
          v-btn(color="primary" dark class="mb-2" v-on="on" @click="item={}") {{ $t('ui.new', { type: $tc('department.title', 1) }) }}
        department-form(v-if="item" :data="item" @close="item=undefined")
    
    v-data-table.elevation-1(
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="this.pagination.total"
      :footer-props='{"items-per-page-options": [10,25,50]}'
      :loading="loading"
    )
      template(v-slot:body="{items}")
        tbody: tr(
          v-for="row, i in items"
          :key="i"
        )
          td {{ row.name }}
          td.justify-center.layout.px-0
            v-icon.mr-2(
              small
              @click="item=row"
            ) edit

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DepartmentForm from '../components/DepartmentForm'

export default {

  components: {
    DepartmentForm,
  },

  data: () => ({
    dialog: false,
    item: undefined,
  }),

  computed: {
    ...mapGetters('entities/departments', [
      'items',
      'loading',
      'pagination',
    ]),
    headers() {
      return [
        { text: this.$t('department.name'), value: 'name', sortable: false },
        { text: '', value: 'name', sortable: false, width: "60" }
      ]
    },
    options: {
      get() {
        const pagination = this.$store.getters['entities/departments/pagination']
        const sort = this.$store.getters['entities/departments/sort']
        return {
          page: pagination.current_page,
          itemsPerPage: pagination.per_page,
          sortBy: [sort.by],
          sortDesc: [sort.descending],
        }
      },
      set(options) {
        this.$store.dispatch('entities/departments/setPaginationAndSort', {
          pagination: {
            current_page: options.page,
            per_page: options.itemsPerPage,
          },
          sort: {
            by: options.sortBy && options.sortBy.length ? options.sortBy[0] : undefined,
            descending: options.sortDesc && options.sortDesc.length ? options.sortDesc[0] : undefined,
          }
        })
      }
    }
  },

  watch: {
    dialog(dialog) {
      if(!dialog) this.item = undefined
    },
    item(item) {
      this.dialog = !!item
    },
  },
}
</script>